var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.94 21.85H73.83V13.938C73.83 11.316 76.268 9.19995 79.327 9.19995C82.363 9.19995 84.801 11.316 84.801 13.938V21.85H93.932C102.005 21.85 108.56 27.531 108.56 34.5V97.7499C108.56 104.719 102.005 110.4 93.932 110.4H20.838C12.765 110.4 6.20999 104.719 6.20999 97.7499V34.5C6.20999 27.531 12.765 21.85 20.838 21.85H29.969V13.938C29.969 11.316 32.407 9.19995 35.443 9.19995C38.502 9.19995 40.94 11.316 40.94 13.938V21.85ZM17.181 97.7499C17.181 99.4979 18.814 100.924 20.838 100.924H93.932C95.956 100.924 97.589 99.4979 97.589 97.7499V47.1499H17.181V97.7499Z",
    fill: "#1C1D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsFilled);
export default __webpack_public_path__ + "static/media/events_filled.b4435432d0607270cd01640d1c97a2af.svg";
export { ForwardRef as ReactComponent };